/**
 * Autumn Home Event hero.
 * Autoplay, chapter and arrow navigation, and a client-side days-left countdown.
 */
(function () {
  var roots = new WeakMap();

  function init(root) {
    if (!root || root.dataset.aphReady === 'true') return;
    root.dataset.aphReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aph-slide]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-aph-panel]'));
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-aph-chapter]'));
    var count = slides.length;
    if (!count) return;

    var duration = parseInt(root.dataset.duration, 10) || 5000;
    var autoplay = root.dataset.autoplay === 'true';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0;
    var start = performance.now();
    var paused = reduce || !autoplay;
    var pausedAt = start;
    var frame = 0;

    function fills() {
      return root.querySelectorAll('[data-aph-fill]');
    }

    function render() {
      slides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === cur);
      });
      panels.forEach(function (el, i) {
        var on = i === cur;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      chapters.forEach(function (el, i) {
        el.classList.toggle('is-active', i === cur);
        el.setAttribute('aria-current', i === cur ? 'true' : 'false');
      });
    }

    function go(index) {
      cur = (index + count) % count;
      start = performance.now();
      paused = reduce;
      if (paused) pausedAt = start;
      render();
    }

    function tick(now) {
      var elapsed = paused ? pausedAt - start : now - start;
      var progress = elapsed / duration;
      if (!paused && autoplay && progress >= 1) {
        go(cur + 1);
        progress = 0;
      }
      var amount = Math.max(0, Math.min(progress, 1));
      fills().forEach(function (el) {
        var i = parseInt(el.dataset.aphFill, 10);
        var width = i < cur ? 100 : i === cur ? amount * 100 : 0;
        el.style.width = width + '%';
      });
      frame = window.requestAnimationFrame(tick);
    }

    function pause() {
      if (paused) return;
      paused = true;
      pausedAt = performance.now();
    }

    function resume() {
      if (!paused || reduce || !autoplay) return;
      start += performance.now() - pausedAt;
      paused = false;
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-aph-go],[data-aph-prev],[data-aph-next]');
      if (!target || !root.contains(target)) return;
      if (target.hasAttribute('data-aph-go')) go(parseInt(target.dataset.aphGo, 10));
      else go(cur + (target.hasAttribute('data-aph-prev') ? -1 : 1));
    });

    function onVisibility() {
      if (document.hidden) pause();
      else resume();
    }
    document.addEventListener('visibilitychange', onVisibility);

    var countdown = root.querySelector('[data-aph-countdown]');
    var countdownTimer = 0;
    function updateDays() {
      if (!countdown) return;
      var end = new Date(countdown.dataset.aphCountdown);
      var ms = end - new Date();
      if (!countdown.dataset.aphCountdown || ms <= 0) {
        countdown.hidden = true;
        return;
      }
      var days = Math.ceil(ms / 86400000);
      countdown.hidden = false;
      countdown.textContent = days === 1 ? 'Last day' : days + ' days left';
    }
    updateDays();
    countdownTimer = window.setInterval(updateDays, 60000);

    render();
    frame = window.requestAnimationFrame(tick);

    roots.set(root, function () {
      window.cancelAnimationFrame(frame);
      window.clearInterval(countdownTimer);
      document.removeEventListener('visibilitychange', onVisibility);
      root.dataset.aphReady = 'false';
    });
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-autumn-hero]');
    Array.prototype.forEach.call(nodes, init);
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-autumn-hero]');
    var destroy = root && roots.get(root);
    if (destroy) destroy();
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
